import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=578555a0&"
import script from "./Load.vue?vue&type=script&lang=ts&"
export * from "./Load.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Load.vue"
export default component.exports